import React, { useState, useEffect, lazy, Suspense } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setTourOpen, setTourPromptOpen } from '@/pages/dashboard/dashboard.slice';
import {  Avatar, Button, Dropdown, Modal } from 'antd';
import '@/assets/less/help-centre.less';

const HelpTour = lazy(() => import('@/common/help-centre/help-tour'));

const HelpCentreButton = ({steps, helpRef, tourTargetId}) => {
  const dispatch = useDispatch();
  
  const [menuOpen, setMenuOpen] = useState(false);
  const [showTourPrompt, setShowTourPrompt] = useState(false);

  const isTourOpen = useSelector(state => state.dashboardPage.isTourOpen);

  useEffect(() => {
    const ignored = localStorage.getItem('tourIgnored');
    const dismissed = sessionStorage.getItem('tourDismissed');
    if (!ignored && !dismissed) {
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setShowTourPrompt(true);
    }
  }, []);

  useEffect(() => {
    const showOnLoad = sessionStorage.getItem('showTourPromptOnLoad');
    if (showOnLoad === 'true') {
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setShowTourPrompt(true);
      sessionStorage.removeItem('showTourPromptOnLoad');
    }
  }, []);

  useEffect(() => {
    dispatch(setTourPromptOpen(showTourPrompt));
    return () => dispatch(setTourPromptOpen(false));
  }, [dispatch, showTourPrompt]);

  const handleTourPrompt = (action) => {
    if (action === 'start') {
      dispatch(setTourOpen(true));
      sessionStorage.setItem('tourDismissed', 'true');
    } else if (action === 'later') {
      sessionStorage.setItem('tourDismissed', 'true');
    } else if (action === 'ignore') {
      localStorage.setItem('tourIgnored', 'true');
    }
    setShowTourPrompt(false);
  };

  const handleMenuClick  = () => {
    setMenuOpen(false)
  };

  function generateMenuItem(label, key, icon) {
    return {
      key,
      icon,
      label,
    };
  }

  const items = [
    generateMenuItem(
      <a href="https://www.youtube.com/playlist?list=PL0wYjtoF8OiESrv5dtcR1q6zTZdPPs5dk" target="_blank" rel="noopener noreferrer" className="help-centre-dropdown__row">
          <i className="ri-youtube-line" />
          <span>Video Tutorials</span>
      </a>,
      '1'),
    { type: 'divider'},
    generateMenuItem(
      <a href="/help" className="help-centre-dropdown__row">
          <i className="ri-book-open-line"/>
          <span>Manuals</span>
      </a>,
      '2'),
    // { type: 'divider'},
    // generateMenuItem(
    //   <Button type="link" className="display-center small-gap pe-2">
    //       <i className="ri-chat-1-line" />
    //       <div>Submit feedback</div>
    //   </Button>, 
    //   '3'),
    { type: 'divider'},
    generateMenuItem(
      <a href="/contact-support" className="help-centre-dropdown__row">
          <i className="ri-customer-service-2-line" />
          <span>Contact Support</span>
      </a>,
      '4'),
    { type: 'divider'},
    generateMenuItem(
      <button
        type="button"
        onClick={() => {
          setMenuOpen(false);
          try {
            const onHome = window?.location?.pathname === '/';
            if (onHome) {
              setShowTourPrompt(true);
            } else {
              sessionStorage.setItem('showTourPromptOnLoad', 'true');
              window.location.href = '/';
            }
          } catch {
            // Fallback: attempt navigation
            window.location.href = '/';
          }
        }}
        className="help-centre-dropdown__row"
      >
          <i className="ri-reserved-line" />
          <span>Reset Tour</span>
      </button>,
      '5')
  ];

  return (
    <>
      <div style={{ paddingLeft: 16 }}>
        <Dropdown 
          trigger={['click']}
          width="390"
          classNames={{ root: 'help-centre-dropdown' }}
          menu={{
            items: items,
            onClick: handleMenuClick,
          }}
          onOpenChange={() => setMenuOpen(!menuOpen)}
        >
          <Avatar id={tourTargetId} size={36} ref={helpRef}
            onClick={() => setMenuOpen(!menuOpen)} 
            icon={<i className="ri-question-mark" />}
          />
        </Dropdown>
      </div>
      {isTourOpen && (
        <Suspense fallback={null}>
          <HelpTour open onClose={() => dispatch(setTourOpen(false))} steps={steps} />
        </Suspense>
      )}
      <Modal
        open={showTourPrompt}
        className="tour-prompt-modal"
        title="Welcome to the DMS!"
        width="fit-content"
        onCancel={() => handleTourPrompt('later')}
        footer={[
          <Button key="start" type="primary" onClick={() => handleTourPrompt('start')}>
            Start Tour
          </Button>,
          <Button key="later" onClick={() => handleTourPrompt('later')}>
            Later
          </Button>,
          <Button key="ignore" danger onClick={() => handleTourPrompt('ignore')}>
            Close and never show me this welcome again
          </Button>,
        ]}
      >
        <p className="tour-prompt-modal__message">Would you like a quick tour?</p>
      </Modal>
    </>
  );
}
export default HelpCentreButton;
